import { render } from "./pagetit.vue?vue&type=template&id=0e28ed51&scoped=true&ts=true"
import script from "./pagetit.vue?vue&type=script&lang=ts"
export * from "./pagetit.vue?vue&type=script&lang=ts"

import "./pagetit.vue?vue&type=style&index=0&id=0e28ed51&lang=less&scoped=true"

import exportComponent from "E:\\develop\\EBIEarthWebApp\\n-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e28ed51"]])

export default __exports__